module.exports = __webpack_public_path__ + "img/grandmother.e7c15c77.png";